<template>
    <v-dialog
        :value="isOpen"
        max-width="1600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onCancel"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmień priorytet zadań
                </h1>
            </v-card-title>
            <v-card-text class="pa-0" style="max-height: 60vh; overflow-y: auto;">
                <v-data-table
                    :headers="priorityHeaders"
                    :items="localTasks"
                    :loading="loading"
                    :mobile-breakpoint="0"
                    :items-per-page="-1"
                    hide-default-footer
                    no-data-text="Brak zadań"
                >
                    <template #item.taskNumber="{item}">
                        {{ item.procNumber }}
                    </template>
                    <template #item.plate="{item}">
                        {{ parseEmptyValue(item.procPlateNumber) }}
                    </template>
                    <template #item.closedFormat="{item}">
                        {{ parseEmptyValue(item.orderObject && item.orderObject.closedFormat) }}
                    </template>
                    <template #item.quantity="{item}">
                        {{ item.procTaskQuantity }}
                    </template>
                    <template #item.date="{item}">
                        {{ formatDate(item.procTaskStartTime) }}
                    </template>
                    <template #item.procTaskDuration="{item}">
                        {{ parseDuration(item.procTaskDurationSeconds) }}
                    </template>
                    <template #item.status="{item}">
                        {{ item.procStatus | lowercase }}
                    </template>
                    <template #item.changePriority="{item}">
                        <div class="d-flex justify-center">
                            <v-checkbox
                                v-model="item.priority"
                                hide-details
                                class="mt-0 pt-0"
                                color="pink"
                                @change="onPriorityChange(item)"
                            />
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onCancel"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    :loading="saving"
                    :disabled="!canUpdatePriority"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse.js'
import { hasUserPermission } from '@/utils/permissionsHandler'

export default {
    name: 'ChangePriorityDialog',
    filters: {
        lowercase(value) {
            value = value.toString()

            return value.toLowerCase()
        }
    },
    mixins: [
        dateFormatter,
        parse
    ],
    props: {
        isOpen: {
            type: Boolean,
        },
        scheduledTasks: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        },
        saving: {
            type: Boolean,
        }
    },
    data() {
        return {
            localTasks: [],
            changedTasks: [],
            priorityHeaders: [
                {
                    text: 'Nr zamówienia',
                    value: 'taskNumber',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Montaż',
                    value: 'plate',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Format',
                    value: 'closedFormat',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Nakład',
                    value: 'quantity',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Zaplanowany start',
                    value: 'date',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Zaplanowany czas',
                    value: 'procTaskDuration',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Zmień priorytet',
                    value: 'changePriority',
                    align: 'center',
                    sortable: false,
                    width: 150
                },
            ]
        }
    },
    computed: {
        canUpdatePriority() {
            return hasUserPermission('schedule_prioritization_update')
        }
    },
    watch: {
        isOpen(newValue) {
            if (newValue) {
                this.localTasks = []
                this.changedTasks = []
            }
        },
        scheduledTasks: {
            handler(newValue) {
                if (this.isOpen && newValue && newValue.length >= 0) {
                    this.initializeLocalTasks()
                }
            },
            deep: true
        }
    },
    methods: {
        initializeLocalTasks() {
            this.localTasks = this.scheduledTasks.map(task => ({
                ...task,
                priority: task.priority || false,
                originalPriority: task.priority || false
            }))
            this.changedTasks = []
        },
        onPriorityChange(item) {
            const existingIndex = this.changedTasks.findIndex(t => t.id === item.id)

            if (item.priority !== item.originalPriority) {
                if (existingIndex === -1) {
                    this.changedTasks.push({
                        id: item.id,
                        procTaskId: item.procTaskId,
                        priority: item.priority
                    })
                } else {
                    this.changedTasks[existingIndex].priority = item.priority
                }
            } else {
                if (existingIndex !== -1) {
                    this.changedTasks.splice(existingIndex, 1)
                }
            }
        },
        onSave() {
            this.$emit('on-save', this.changedTasks)
        },
        onCancel() {
            this.changedTasks = []
            this.$emit('on-close')
        }
    }
}
</script>
